import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect } from "react";
import { NavDropdown } from "react-bootstrap";
import { useClearCache } from "./commons";
import { confirmBox } from "./Boxes";
import { I18n, Translate } from "react-redux-i18n";
export const KNavDropdownItem = ({ disabled, onClick, children }) => (_jsx(NavDropdown.Item, { onClick: onClick, disabled: disabled, children: children }));
export const KNavDropdownDivider = () => _jsx(NavDropdown.Divider, {});
const VersionDropdown = ({ className, id, children, title, compact, noCaret, small, alignRight }) => {
    const { isLatestVersion, emptyCacheStorage } = useClearCache();
    const askEmptyCache = useCallback(async () => {
        if (await confirmBox({
            message: I18n.t("generic.newVersion"),
            yesText: I18n.t("generic.yes"),
            noText: I18n.t("generic.no"),
        })) {
            await emptyCacheStorage();
        }
    }, [emptyCacheStorage]);
    useEffect(() => {
        if (!isLatestVersion) {
            askEmptyCache().catch(console.error);
        }
    }, [isLatestVersion, askEmptyCache]);
    let latestWarning = null;
    if (!isLatestVersion) {
        latestWarning = _jsx("i", { style: {
                position: "relative",
                fontSize: "0.5rem",
                top: "-0.5rem",
            }, className: "fa-solid fa-circle text-warning" });
    }
    return (_jsxs(NavDropdown, { id: id, title: _jsxs(_Fragment, { children: [title, latestWarning] }), align: alignRight ? "end" : "start", className: `${id} ${small ? "small" : ""} ${noCaret ? "no-caret" : ""} ${compact ? "compact" : ""} ${className ? className : ""}`, children: [!isLatestVersion ? (_jsx(KNavDropdownItem, { onClick: () => askEmptyCache && askEmptyCache(), children: _jsx("i", { children: _jsx(Translate, { className: "text-warning", value: "generic.upgrade" }) }) })) : null, children, process.env.REACT_APP_VERSION ? _jsx("i", { style: { marginTop: 10, padding: "0 25px", fontSize: "0.5em", color: "#CCC", display: "block", textAlign: "right" }, children: process.env.REACT_APP_VERSION }) : null] }));
};
export const KNavDropdown = (props) => {
    const { versionVerifier, id, title, alignRight, small, noCaret, compact, className, children } = props;
    return versionVerifier ? _jsx(VersionDropdown, { ...props }) : (_jsx(NavDropdown, { id: id, title: title, align: alignRight ? "end" : "start", className: `${id} ${small ? "small" : ""} ${noCaret ? "no-caret" : ""} ${compact ? "compact" : ""} ${className ? className : ""}`, children: children }));
};
